module.exports = __webpack_public_path__ + "img/audio.a930296d.png";